import React, { useEffect, useState } from 'react';
import CollectionGroup from './CollectionGroup.jsx';
import Axios from 'axios';
import { useMediaQuery } from 'react-responsive'
import { mergeDeep } from '../utils/mergeDeep.js'

export default function CollectionProducts(props) {
  const isDesktop = useMediaQuery({ minWidth: 720 });
  const [thumbnails, setThumbnails] = useState(false);
  const layout = props.metafields && props.metafields.layout || 'normal';
  useEffect(() => {
    if (!thumbnails && layout !== 'condensed') {
      if (isDesktop) {
        Axios.get(`/collections/${props.collectionHandle}?view=_json_thumbs`).then(response => {
          setThumbnails(response.data);
        })
      }
    }
  }, [isDesktop])
  const hiddenTitles = props.metafields && props.metafields.hide_titles ? props.metafields.hide_titles.split(',') : [];
  const hiddenThumbnails = props.metafields && props.metafields.hide_thumbnails ? props.metafields.hide_thumbnails.split(',') : [];
  const groupDesktopTitles = props.metafields && props.metafields.group_titles && props.layout === 'condensed' ? props.metafields.group_titles : {};
  const hiddenBorders = props.metafields && props.metafields.hide_borders ? props.metafields.hide_borders.split(',') : [];
  let groupedProducts = [];
  if (props.metafields && props.metafields.grouped === 'true') {
    groupedProducts = props.groups.map(group => {
      const limit = props.metafields.group_limits && props.metafields.group_limits[group] || false;
      const tag = `${props.metafields.group_by}:${group}`;
      return {
        group,
        limit,
        border: hiddenBorders.includes(group),
        hideThumbnails: hiddenThumbnails.includes(group),
        title: hiddenTitles.includes(group) ? '' : group,
        desktopTitle: hiddenTitles.includes(group) ? '' : groupDesktopTitles[group] ? groupDesktopTitles[group] : group,
        products: props.products.filter(product => product.tags.includes(tag))
      }
    })
  } else {
    groupedProducts.push({
      group: 'default',
      title: '',
      products: props.products
    })
    hiddenTitles.push('default');
  }
  if (props.swaps) {
    props.swaps.forEach(swap => {
      for (let i = 1; i < 11; i++) {
        const product = swap[`product_${i}`];
        const destination = swap[`destination_${i}`];
        const device = swap[`devices_${i}`];
        const insert = swap[`insert_${i}`];
        if (isDesktop && device === 'mobile') {
          continue;
        } else if (!isDesktop && device === 'desktop') {
          continue;
        }
        if (product && destination) {
          const productArray = groupedProducts.find(group => {
            return group.products.some(p => p.handle == product);
          })
          const destinationArray = groupedProducts.find(group => {
            return group.products.some(p => p.handle == destination);
          })
          if (productArray && destinationArray) {
            const productIndex = productArray.products.findIndex(p => p.handle === product);
            const productCopy = productArray.products.splice(productIndex, 1)[0];
            let destinationIndex = destinationArray.products.findIndex(p => p.handle === destination);
            if (insert === 'afterend') {
              destinationIndex++;
            }
            destinationArray.products.splice(destinationIndex, 0, productCopy);
          }
        }
      }
    })
  }
  if (props.groupOverrides) {
    groupedProducts.forEach(group => {
      const groupOverrides = props.groupOverrides[group.group];
      if (groupOverrides && groupOverrides.products) {
        group.products = group.products.map(product => JSON.parse(JSON.stringify(product)));
        Object.keys(groupOverrides.products).forEach(compHandle => {
          const product = group.products.find(({ handle }) => handle === compHandle);
          mergeDeep(product, groupOverrides.products[compHandle], {overrideImage: true})
        })
      }
    })
  }
  if (props.texts) {
    groupedProducts.forEach(groupedProduct => {
      const groupTexts = props.texts.filter(({ group }) => group === groupedProduct.group)
      groupedProduct.texts = groupTexts;
    })
  }
  return (
    <article className="products-wrap" role="grid">
      {groupedProducts.map((group, i) => {
        return <CollectionGroup key={i} group={group} layout={layout} collectionHandle={props.collectionHandle} thumbnails={thumbnails} blocks={props.blocks} isDesktop={isDesktop} columnCount={props.columnCount} />
      })}
    </article>
  )
}